import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TableModule } from 'primeng/table';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { LocalizationService } from '../../core/localization/localization.service';
import { WorkflowApiService } from './workflow-api.service';
import { WorkflowTriggerSubscriptionItem } from './workflow-catalog.models';

@Component({
  standalone: true,
  selector: 'ain-workflow-trigger-subscriptions',
  imports: [AinPageComponent, AinStateComponent, TableModule, RouterLink],
  template: `
    <ain-page [title]="t('workflow.triggers.title')" [description]="t('workflow.triggers.description')">
      <a routerLink="/workflow/definitions">{{ t('workflow.definitions.title') }}</a>
      @if (loading()) {
        <ain-state type="loading" [title]="t('common.loading')" />
      } @else if (error()) {
        <ain-state type="error" [title]="error() ?? ''" />
      } @else {
        <p-table [value]="subscriptions()" [paginator]="true" [rows]="15">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ t('workflow.triggers.processDefinition') }}</th>
              <th>{{ t('workflow.triggers.triggerName') }}</th>
              <th>{{ t('workflow.triggers.triggerType') }}</th>
              <th>{{ t('workflow.triggers.configuration') }}</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.processDefinitionName }}</td>
              <td>{{ row.triggerName }}</td>
              <td>{{ row.triggerType }}</td>
              <td><code>{{ summarizeConfig(row.configurationJson) }}</code></td>
              <td>
                <a [routerLink]="['/workflow/definitions', row.processDefinitionId]">{{ t('common.open') }}</a>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
    </ain-page>
  `,
  styles: [`
    a { display: inline-block; margin-bottom: 12px; }
    code { font-size: 11px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: inline-block; max-width: 320px; }
  `]
})
export class WorkflowTriggerSubscriptionsComponent implements OnInit {
  private readonly api = inject(WorkflowApiService);
  private readonly localization = inject(LocalizationService);

  readonly subscriptions = signal<WorkflowTriggerSubscriptionItem[]>([]);
  readonly loading = signal(true);
  readonly error = signal<string | null>(null);

  ngOnInit(): void {
    this.api.listTriggerSubscriptions().subscribe({
      next: items => {
        this.subscriptions.set(items);
        this.loading.set(false);
      },
      error: () => {
        this.error.set(this.t('common.loadFailed'));
        this.loading.set(false);
      }
    });
  }

  summarizeConfig(raw: string): string {
    if (!raw?.trim()) return '{}';
    return raw.length > 120 ? `${raw.slice(0, 117)}...` : raw;
  }

  t(key: string): string {
    return this.localization.translate(key);
  }
}
